import api from '../../utils/api';

export const fetchActiveHero = async () => {
  const response = await api.get('/hero/active');
  return response.data.data;
};

// Homepage slider — saare active slides (admin ke "Hero Banners" tab se manage)
export const fetchActiveHeroSlides = async () => {
  const response = await api.get('/hero/slides');
  return response.data.data || [];
};
